import { Component, OnInit, ViewChild, Inject, inject, LOCALE_ID, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../../_services/shared.service';
import { DynamicBarService } from '../../_components/dynamic-bar/dynamic-bar.service';
import { ThrobberService } from '../../_services/throbber.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { ThemeManagerService } from '../../_services/theme.manager.service';
import { HomeBarraComponent } from 'src/app/home/home-barra.component';
import { BarraSimpleComponent } from 'src/app/_components/glm-barras/barra-simple/barra-simple.component';
import { EstudioResumenBarraComponent } from '../estudio/resumen/estudio-resumen-barra.component';
import { MapaCurricularBarraComponent } from '../estudio/mapa-curricular/mapa-curricular-barra.component';
import { UnidadEtapasBarraComponent } from '../estudio/unidad-etapas/unidad-etapas-barra.component';
import { RetroalimentacionBarraComponent } from '../estudio/retroalimentacion/retroalimentacion-barra/retroalimentacion-barra.component';
import { UnidadFamiliaBarraComponent } from '../estudio/unidad-familia/unidad-familia-barra.component';
import { NivelacionesBarraComponent } from '../nivelaciones/nivelaciones-barra.component';
import { NivelacionesCitacionMcpBarraComponent } from '../nivelaciones/citacion-materia-curso/nivelaciones-citacion-mcp-barra.component';
import { NivelacionesReporteBarraComponent } from '../nivelaciones/nivelaciones-reporte/nivelaciones-reporte-barra.component';
import { NivelacionesAlumnoBarraComponent } from '../nivelaciones/nivelaciones-alumnos/nivelaciones-alumno-barra.component';
import { FamiliaHijoBarraComponent } from '../estudio/familia-hijo/familia-hijo-barra.component';
import { AsistenciaCursoBarraComponent } from '../asistencia/asistencia-curso/asistencia-curso-barra.component';
import { AsistenciaReporteGeneralBarraComponent } from '../asistencia/reporte-general/reporte-general-barra.component';
import { AsistenciaAlertasBarraComponent } from '../asistencia/reporte-alertas/reporte-alertas-barra.component';
import { AsistenciaDirectorCursoBarraComponent } from '../asistencia/reporte-director-curso/reporte-director-curso-barra.component';
import { AsistenciaReporteCursosBarraComponent } from '../asistencia/reporte-curso/reporte-curso-barra.component';
import { ReporteVigilanciaTareasBarraComponent } from '../asistencia/reporte-vigilancia-tareas/reporte-vigilancia-barra.component';
import { AsistenciaReporteDireccionAcademicaBarraComponent } from '../asistencia/reporte-direccion-academica/reporte-direccion-academica-barra.component';
import { DashboardRetroalimentacionBarraComponent } from '../estudio/retroalimentacion/dashboard/dashboard-retroalimentacion-barra.component';
import { RetroalimentacionMateriasBarraComponent } from '../estudio/retroalimentacion/retroalimentacion-mis-materias/retroalimentacion-materias-barra.component';
import { ReunionesListaBarraComponent } from '../reuniones/reuniones-lista/reuniones-lista-barra.component';
import { ReunionBarraComponent } from '../reuniones/reunion/reunion-barra.component';
import { MatriculaHomeBarraComponent } from 'src/app/_components/glm-barras/matricula-home-barra/matricula-home-barra.component';
import { AdmisionesBarraComponent } from 'src/app/_components/glm-barras/admisiones-barra.component/admisiones-barra.component';
import { ReconocimientosBarraComponent } from 'src/app/_components/glm-barras/reconocimientos-barra/reconocimientos-barra.component';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('drawer') drawer!: MatSidenav;

  currentPath: string[] = []; // 🔹 segmentos de la ruta actual

  expanded = true;
  shouldSidenavBeOpened = true;
  private autoCollapseTimer: any; // Variable para almacenar el timer

  private themeManager = inject(ThemeManagerService);
  theme = this.themeManager.theme;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  isLogin = true;
  isAdmisiones = true;
  urlAyuda = "https://ayuda.mi.glm.edu.co";
  verAyuda = this.urlAyuda.length > 0;
  activeLang: string;
  topBarComponent: any;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private matIconReg: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private sharedService: SharedService,
    private dynamicBarService: DynamicBarService,
    private throbberService: ThrobberService,
    private overlayContainer: OverlayContainer,
    @Inject(LOCALE_ID) protected localeId: string,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.matIconReg.addSvgIcon(
      'glm-logo',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/logo-glm/glm-logo-blanco.svg')
    );

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.throbberService.setThrobberState(true);
      }
      if (event instanceof NavigationError) {
        this.throbberService.setThrobberState(false);
      }
      if (event instanceof NavigationEnd) {
        this.isLogin = event.url.toLowerCase().indexOf('login') > -1 ||
          event.url.toLowerCase().indexOf('reset') > -1;

        this.isAdmisiones = (
          event.url.toLowerCase().indexOf('v1/admisiones/aspirante') === 1 ||
          event.url.toLowerCase().indexOf('v1/admisiones/notloggedin') === 1 ||
          event.url.toLowerCase().indexOf('admisiones/formulario') === 1 ||
          event.url.toLowerCase().indexOf('v1/admisiones-registro/formulario') === 1
        );
        this.throbberService.setThrobberState(false);
      }
      if (event instanceof NavigationEnd) {
        this.isLogin = event.url.toLowerCase().indexOf('login') > -1 ||
          event.url.toLowerCase().indexOf('reset') > -1;

        this.isAdmisiones = (
          event.url.toLowerCase().indexOf('v1/admisiones/aspirante') === 1 ||
          event.url.toLowerCase().indexOf('v1/admisiones/notloggedin') === 1 ||
          event.url.toLowerCase().indexOf('admisiones/formulario') === 1 ||
          event.url.toLowerCase().indexOf('v1/admisiones-registro/formulario') === 1
        );

        // 🔹 solo actualizamos breadcrumb cuando no es login
        if (!this.isLogin) {
          this.updatePath(event.urlAfterRedirects ?? event.url);
        } else {
          this.currentPath = [];
        }

        this.throbberService.setThrobberState(false);
      }
    });
  }

  // gotobakc button

  goBackLevel(): void {
    // Si no hay path calculado, manda al home
    if (!this.currentPath || this.currentPath.length === 0) {
      this.navigateHome();
      return;
    }

    const segments = [...this.currentPath];

    // Caso: solo 'home' → ir al home normal
    if (segments.length === 1 && segments[0] === 'home') {
      this.navigateHome();
      return;
    }

    // Eliminar el último segmento (subir un nivel)
    segments.pop();

    // Si después de eliminar ya no queda nada → ir al home
    if (!segments.length) {
      this.navigateHome();
      return;
    }

    const newUrl = '/' + segments.join('/');
    this.router.navigate([newUrl]);
  }


  // regresar al home toolbar

  navigateHome() {
    this.router.navigate(['/']);
  }

  private updatePath(url: string): void {
    const clean = url.split('?')[0].split('#')[0]; // sin query ni fragmento
    const segments = clean.split('/').filter(Boolean);

    // si quieres puedes filtrar cosas como 'v1'
    this.currentPath = segments;
  }

  // construye el link acumulando segmentos
  buildLink(index: number): string {
    const upTo = this.currentPath.slice(0, index + 1);
    return '/' + upTo.join('/');
  }

  ngOnInit() {
    // Aplicar tema inicial basado en localStorage o preferencia del sistema
    this.applyInitialTheme();

    this.activeLang = this.localeId.substring(0, 2);

    // Configurar el temporizador para colapsar el sidenav después de 8 segundos
    this.setAutoCollapseTimer();

    this.dynamicBarService.getDynamicBarObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.setComponent) {
        let component, inputs;
        switch (data.tipo) {
          case 'home-barra':
            component = HomeBarraComponent;
            inputs = [];
            break;
          case 'barra-simple':
            component = BarraSimpleComponent;
            inputs = data.inputs;
            break;
          case 'estudio-resumen':
            component = EstudioResumenBarraComponent;
            inputs = [];
            break;
          case 'estudio-mapa-curricular':
            component = MapaCurricularBarraComponent;
            inputs = [];
            break;
          case 'estudio-unidad-etapas':
            component = UnidadEtapasBarraComponent;
            inputs = data.inputs;
            break;
          case 'estudio-retroalimentacion':
            component = RetroalimentacionBarraComponent;
            inputs = data.inputs;
            break;
          case 'estudio-unidad-familia':
            component = UnidadFamiliaBarraComponent;
            inputs = data.inputs;
            break;
          case 'nivelaciones-barra':
            component = NivelacionesBarraComponent;
            inputs = [];
            break;
          case 'nivelaciones-citacion-mcp-barra':
            component = NivelacionesCitacionMcpBarraComponent;
            inputs = data.inputs;
            break;
          case 'nivelaciones-reporte-barra':
            component = NivelacionesReporteBarraComponent;
            inputs = [];
            break;
          case 'nivelaciones-alumno-barra':
            component = NivelacionesAlumnoBarraComponent;
            inputs = [];
            break;
          case 'familia-hijo':
            component = FamiliaHijoBarraComponent;
            inputs = data.inputs;
            break;
          case 'asistencia-curso-barr':
            component = AsistenciaCursoBarraComponent;
            inputs = data.inputs;
            break;
          case 'asistencia-reporte-general-barra':
            component = AsistenciaReporteGeneralBarraComponent;
            inputs = [];
            break;
          case 'asistencia-alertas-barra':
            component = AsistenciaAlertasBarraComponent;
            inputs = [];
            break;
          case 'asistencia-director-curso-barra':
            component = AsistenciaDirectorCursoBarraComponent;
            inputs = data.inputs;
            break;
          case 'asistencia-reporte-cursos-barra':
            component = AsistenciaReporteCursosBarraComponent;
            inputs = [];
            break;
          case 'reporte-vigilancia-tareas-barra':
            component = ReporteVigilanciaTareasBarraComponent;
            inputs = [];
            break;
          case 'asistencia-reporte-direccion-academica-barra':
            component = AsistenciaReporteDireccionAcademicaBarraComponent;
            inputs = [];
            break;
          case 'dashboard-retroalimentacion-barra':
            component = DashboardRetroalimentacionBarraComponent;
            inputs = data.inputs;
            break;
          case 'dashboard-retroalimentacion-materias-barra':
            component = RetroalimentacionMateriasBarraComponent;
            inputs = data.inputs;
            break;
          case 'reuniones-lista-barra':
            component = ReunionesListaBarraComponent;
            inputs = [];
            break;
          case 'reunion-barra':
            component = ReunionBarraComponent;
            inputs = [];
            break;
          case 'matricula-home-barra':
            component = MatriculaHomeBarraComponent;
            inputs = [];
            break;
          case 'admisiones-barra':
            component = AdmisionesBarraComponent;
            inputs = [];
            break;
          case 'reconocimientos-barra':
            component = ReconocimientosBarraComponent;
            inputs = [];
            break;
          default:
            component = HomeBarraComponent;
            inputs = [];
            break;
        }

        this.topBarComponent = { component, inputs };
        this.cdRef.detectChanges();
      }
    });

    this.isHandset$.subscribe(isHandset => {
      this.shouldSidenavBeOpened = !isHandset;
    });
  }

  // Método para expandir/colapsar manualmente
  toggleExpand() {
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();

    // Solo reiniciar el temporizador si se está expandiendo (no al colapsar)
    // if (this.expanded) {
    //   this.setAutoCollapseTimer();
    // } else {
    //   // Si se está colapsando, cancelar el temporizador
    //   if (this.autoCollapseTimer) {
    //     clearTimeout(this.autoCollapseTimer);
    //   }
    // }
  }

  // Método para configurar el temporizador
  private setAutoCollapseTimer(): void {
    if (this.autoCollapseTimer) {
      clearTimeout(this.autoCollapseTimer);
    }

    // Establecer nuevo temporizador
    this.autoCollapseTimer = setTimeout(() => {
      this.expanded = false;
      this.cdRef.detectChanges();
    }, 15000);
  }


  toggleTheme() {
    this.themeManager.toggleTheme();
    this.applyTheme(this.theme() === 'dark');
  }

  private applyInitialTheme(): void {
    // Verificar si hay una preferencia guardada en localStorage
    const savedTheme = localStorage.getItem('user_theme_preference');

    if (savedTheme === 'dark' || savedTheme === 'light') {
      // Si hay preferencia guardada, usarla
      this.themeManager.setTheme(savedTheme);
      this.applyTheme(savedTheme === 'dark');
    } else {
      // Si no hay preferencia guardada, usar la del sistema
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const initialTheme = prefersDark ? 'dark' : 'light';
      this.themeManager.setTheme(initialTheme);
      this.applyTheme(prefersDark);
    }
  }

  private applyTheme(isDark: boolean): void {
    const bodyClassList = this.document.body.classList;
    const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;

    if (isDark) {
      bodyClassList.remove('light-theme');
      bodyClassList.add('dark-theme');
      overlayContainerClasses.add('dark-theme');
      overlayContainerClasses.remove('light-theme');
    } else {
      bodyClassList.remove('dark-theme');
      bodyClassList.add('light-theme');
      overlayContainerClasses.add('light-theme');
      overlayContainerClasses.remove('dark-theme');
    }
  }

  toggleSidenav() {
    this.drawer.toggle();
    // Reiniciar el temporizador cuando el usuario interactúa manualmente
    this.setAutoCollapseTimer();
  }
}